import { Link } from 'react-router-dom';

export default function CTASection({ content }) {
  const title = content?.title || 'Your Career Transformation Starts Today';
  const description = content?.description || 'Over 50,000 Nigerians have already transformed their careers and businesses with LearnHub. From Lagos to Kano, our learners are getting hired, launching startups, and growing their income.';
  const instructorHighlight = content?.instructorHighlight || 'Instructors from Flutterwave, Paystack, Jumia, CcHub & top Nigerian universities';
  const primaryButtonText = content?.primaryButtonText || 'Create Free Account';
  const primaryButtonLink = content?.primaryButtonLink || '/signup';
  const secondaryButtonText = content?.secondaryButtonText || 'Browse All Courses';
  const secondaryButtonLink = content?.secondaryButtonLink || '/courses';
  const highlights = content?.highlights && content.highlights.length > 0 ? content.highlights : [
    'No credit card required',
    'Learn at your own pace',
    'Certificates included'
  ];

  return (
    <section className="py-20 relative overflow-hidden bg-teal-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=vibrant%20Nigerian%20African%20graduates%20celebrating%20success%20university%20degree%20ceremony%20joy%20happiness%20smiling%20Lagos%20Nigeria%20colourful%20academic%20robes%20bright%20sunlight&width=1440&height=600&seq=ngcta1&orientation=landscape"
          alt="Nigerian graduates celebrating"
          className="w-full h-full object-cover object-top opacity-20 filter brightness-50"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-teal-950/95 via-teal-900/90 to-teal-950/95" />
      </div>
      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <div className="w-16 h-16 flex items-center justify-center bg-teal-500/20 border border-teal-400/30 rounded-2xl mx-auto mb-6 backdrop-blur-sm shadow-md">
          <i className="ri-rocket-2-line text-teal-300 text-3xl" />
        </div>
        <h2 className="text-3xl sm:text-4xl font-extrabold text-white mb-4 drop-shadow-md">
          {title}
        </h2>
        <p className="text-teal-100 text-base sm:text-lg mb-3 leading-relaxed max-w-2xl mx-auto font-normal drop-shadow-sm">
          {description}
        </p>
        <p className="text-teal-300 text-sm mb-8 font-semibold">
          {instructorHighlight}
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4">
          <Link
            to={primaryButtonLink}
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-white text-teal-800 font-bold rounded-xl hover:bg-teal-50 transition-all cursor-pointer whitespace-nowrap shadow-lg shadow-teal-950/40 active:scale-95"
          >
            <i className="ri-user-add-line" />
            {primaryButtonText}
          </Link>
          <Link
            to={secondaryButtonLink}
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-teal-800/80 hover:bg-teal-800 border border-teal-600/40 text-white font-semibold rounded-xl transition-all cursor-pointer whitespace-nowrap backdrop-blur-sm active:scale-95"
          >
            {secondaryButtonText}
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-6 mt-8 text-teal-200 text-sm font-medium">
          {highlights.map((h, i) => (
            <span key={i} className="flex items-center gap-1.5">
              <i className="ri-check-line text-teal-400" /> {h}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
